import { Box, Stack, styled } from "@mui/material";
import ButtonDisabled from "images/button-disabled.svg";
import ButtonIdleActive from "images/button-idle-active.svg";
import ButtonIdleHover from "images/button-idle-hover.svg";
import ButtonIdle from "images/button-idle.svg";
import ButtonSuccess from "images/button-success.svg";

export const Container = styled(Stack)`
  position: relative;
  padding: 15px;
  width: 272px;
  height: fit-content;

  align-items: stretch;
  flex-wrap: wrap;
  gap: 4px;

  border-radius: 30px;
  border-top-left-radius: 70px;
  border-top-right-radius: 70px;
  border: 1px solid #f1f1f1;
  background: rgba(234, 235, 239, 0.4);

  box-sizing: border-box;
`;
export const ButtonContainer = styled(Stack)`
  position: relative;
  width: 239px;
  height: 239px;

  justify-content: center;
  align-items: center;
  gap: 0;

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  border-radius: 60px;
`;

export const LogoSplash = styled(Stack)`
  width: 87px;
  height: 87px;

  justify-content: center;
  align-items: center;

  background-color: transparent;
  border-radius: 50%;
  overflow: hidden;
`;

export const Logo = styled(Box)`
  width: 157px;
  height: 87px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;

  cursor: pointer;
  border-radius: 6px;
`;

export const HalfHolder = styled(Stack)`
  position: absolute;
  top: 14px;
  left: 14px;
  right: 14px;
  height: 120px;

  justify-content: center;
  align-items: center;

  border-top-left-radius: 48px;
  border-top-right-radius: 48px;
  overflow: hidden;

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  user-select: none;
`;

export const Led = styled(Box)`
  margin-top: 3px;
  margin-bottom: 1px;
  height: 26px;
  width: 9px;

  background-color: darkgrey;
  border-radius: 3px;

  &.idle {
    background-color: lightgrey;
  }

  &.disabled {
    background-color: lightgrey;
  }

  &.error {
    background-color: red;
  }

  &.success {
    background-color: #72ff13;
  }

  border: 1px solid darkgrey;
  z-index: 10;
`;

export const LogoHolder = styled(LogoSplash)`
  color: grey;
  background-color: #fff;
`;

export const EmptyLogoHolder = styled(Stack)`
  flex: 0 0 auto;
  width: 87px;
  height: 87px;

  justify-content: center;
  align-items: center;

  background-color: transparent;
  border-radius: 50%;
  overflow: hidden;

  user-select: none;
`;

export const TextMosaic = styled(Box)`
  /* display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center; */

  width: 140px;
  height: 140px;

  font-size: 10px;
  font-weight: 600;

  overflow-wrap: anywhere;
  word-wrap: anywhere;

  transform: rotate(-10deg);
`;

export const ButtonIndicator = styled(Stack)`
  width: 87px;
  height: 87px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  cursor: pointer;
  user-select: none;

  &.idle {
    background-image: url(${ButtonIdle});
    background-position: center;
    background-repeat: no-repeat;
  }

  &.idle:hover,
  &.success:hover {
    background-image: url(${ButtonIdleHover});
    background-position: center;
    background-repeat: no-repeat;
  }

  &.idle:active {
    background-image: url(${ButtonIdleActive});
    background-position: center;
    background-repeat: no-repeat;
  }

  &.success {
    background-image: url(${ButtonSuccess});
    background-position: center;
    background-repeat: no-repeat;
  }

  &.disabled {
    background-image: url(${ButtonDisabled});
    background-position: center;
    background-repeat: no-repeat;
  }

  &.error {
    background-image: url(${ButtonIdle});
    background-position: center;
    background-repeat: no-repeat;
  }

  z-index: 10;
`;

export const Prop = styled(Stack)`
  flex-direction: row;
  justify-content: flex-start;
  gap: 5px;
`;

export const Label = styled(Box)`
  font-family: sans-serif;
  font-size: 14px;
  color: #9a9ea5;
`;

export const Value = styled(Box)`
  flex: 1 1 auto;
  font-family: sans-serif;
  font-size: 14px;
  color: #272727;
  text-align: left;
  overflow-wrap: anywhere;
  word-wrap: anywhere;
`;
